import {InvalidArgumentException} from "../../js/errors/Exceptions";
import {faArrowDown, faArrowRightLong, faArrowUp, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

/**
 * Returns id of TmTransitionRuleInput in the following format: <code>transition-rule-input-INDEX</code>
 * @param index {number}
 * @return {string}
 */
export const getTmTransitionRuleInputId = (index) => {
    return 'transition-rule-input-' + index;
}

/**
 * Parses <code>INDEX</code> (as number) from given <code>id</code> that is in required format
 * @param id {string} must be in following format: <code>transition-rule-input-INDEX</code>
 * @return {number}
 */
export const parseTmTransitionRuleInputIndexFromId = (id) => {
    if (!/^transition-rule-input-\d+$/.test(id)){
        throw new InvalidArgumentException("id must be in the following format: 'transition-rule-input-INDEX'," +
            "where INDEX integer number >= 0");
    }
    return parseInt(id.match(/\d+/g)[0]);
}


// states are valid states names
export default function TmTransitionRuleInputComponent({index, transitionRulesInputsCount,
                                                           transitionRuleInput, statesNames, alphabetChars,
                                                           onStartStateChanged, onEndStateChanged,
                                                           onLookedCharChanged, onCharToWriteChanged, onHeadDirectionChanged,
                                                           onRaiseUpInput, onPutDownInput, onDeleteInput}){
    // return row with all inputs
    return(
        <div className="row m-0 mt-1">

            {/* Start state */}
            <div className="col-2">
                <select className='form-control'
                        value={transitionRuleInput.startState}
                        onChange={(e) => onStartStateChanged(e.target.value, index)}>
                    <option value={''}>
                        {/* 'Nothing selected' option */}
                    </option>
                    {
                        statesNames.map((stateName, idx) => (
                            <option key={idx} value={stateName}>
                                {stateName}
                            </option>
                        ))
                    }
                </select>
            </div>

            {/* Looked char */}
            <div className="col-1">
                <select className='form-control'
                        value={transitionRuleInput.lookedChar}
                        onChange={(e) => onLookedCharChanged(e.target.value, index)}>
                    <option value={''}>
                        {/* 'Nothing selected' option */}
                    </option>
                    {
                        alphabetChars.map((ch, idx) => (
                            <option key={idx} value={ch}>
                                {ch}
                            </option>
                        ))
                    }
                </select>
            </div>

            {/* ---> */}
            <div className="col-1 d-flex flex-row justify-content-center align-items-center">

                <p className="m-0 p-0">
                    <FontAwesomeIcon icon={faArrowRightLong}/>
                </p>

            </div>

            {/* End state */}
            <div className="col-2">
                <select className='form-control'
                        value={transitionRuleInput.endState}
                        onChange={(e) => onEndStateChanged(e.target.value, index)}>
                    <option value={''}>
                        {/* 'Nothing selected' option */}
                    </option>
                    {
                        statesNames.map((stateName, idx) => (
                            <option key={idx} value={stateName}>
                                {stateName}
                            </option>
                        ))
                    }
                </select>
            </div>

            {/* Char to write */}
            <div className="col-1">
                <select className='form-control'
                        value={transitionRuleInput.charToWrite}
                        onChange={(e) => onCharToWriteChanged(e.target.value, index)}>
                    <option value={''}>
                        {/* 'Nothing selected' option */}
                    </option>
                    {
                        alphabetChars.map((ch, idx) => (
                            <option key={idx} value={ch}>
                                {ch}
                            </option>
                        ))
                    }
                </select>
            </div>

            {/* Head direction */}
            <div className="col-2">
                <select className='form-control'
                        value={transitionRuleInput.headDirection}
                        onChange={(e) => onHeadDirectionChanged(e.target.value, index)}>
                    <option value="NONE">NONE</option>
                    <option value="LEFT">LEFT</option>
                    <option value="RIGHT">RIGHT</option>
                </select>
            </div>

            {/* Up, Down, Delete buttons */}
            <div className="col-3">
                <div className={'d-flex flex-row justify-content-center'}>
                    <button type="button" className="btn btn-primary m-1 mb-0"
                            disabled={index === 0}
                            onClick={(e) => onRaiseUpInput(index)}>
                        <p className={'m-0 p-0'}><FontAwesomeIcon icon={faArrowUp}/></p>
                    </button>

                    <button type="button" className="btn btn-primary m-1 mb-0"
                            disabled={index === transitionRulesInputsCount - 1}
                            onClick={(e) => onPutDownInput(index)}>
                        <p className={'m-0 p-0'}><FontAwesomeIcon icon={faArrowDown}/></p>
                    </button>

                    <button type="button" className="btn btn-danger m-1 mb-0"
                            disabled={transitionRulesInputsCount === 1}
                            onClick={(e) => onDeleteInput(index)}>
                        <p className={'m-0 p-0'}><FontAwesomeIcon icon={faTrash}/></p>
                    </button>
                </div>
            </div>
        </div>
    );
}
